import ActionsDropdown, { Action } from 'components/ActionsDropdown'
import { Link, PencilLine, Copy } from 'lucide-react'
import { useMemo } from 'react'

import useCopyToClipboard from 'hooks/useCopyToClipboard'
import getFullUserUrl from 'helpers/getFullUserUrl'
import { useSelector } from 'react-redux'
import { getDisplayUsername, userSlice } from '@wellesley/user'
import { getRoute } from '@wellesley/router'

type ManageGroupProps = {
  trigger?: React.ReactNode
  isPortal?: boolean
  triggerClass?: string
  onOpenChange?: (open: boolean) => void
  align?: 'start' | 'end'
  alignOffset?: number
}

const iconSize = 20
export const PersonalActions = ({
  isPortal = true,
  trigger,
  triggerClass,
  onOpenChange,
  align = 'start',
  alignOffset,
}: ManageGroupProps) => {
  const user = useSelector(userSlice.selectors.selectCurrentUser)
  const [copyUsername] = useCopyToClipboard({
    textToCopy: getDisplayUsername(user?.username),
    toastMsg: 'Username is copied to clipboard',
  })
  const [copyProfileUrl] = useCopyToClipboard({
    textToCopy: user ? getFullUserUrl(user) : '',
    toastMsg: 'Profile URL is copied to clipboard',
  })

  const actions: Action[] = useMemo(
    () => [
      {
        name: 'Edit profile',
        icon: <PencilLine size={iconSize} />,
        link: getRoute('/settings/:tab?', { tab: 'profile' }),
      },
      {
        name: 'Copy username',
        icon: <Copy size={iconSize} />,
        handler: copyUsername,
      },
      {
        name: 'Copy profile URL',
        icon: <Link size={iconSize} />,
        handler: copyProfileUrl,
      },
    ],
    [copyUsername, copyProfileUrl],
  )

  return (
    <>
      <ActionsDropdown
        actions={actions}
        onOpenChange={onOpenChange}
        desktopModalBehavior={false}
        mobileBehavior="dropdown"
        dropdownClassName="w-[288px]"
        align={align}
        alignOffset={alignOffset}
        isPortal={isPortal}
        triggerVariant="none"
        triggerSize="icon_xs"
        triggerClass={triggerClass}
        trigger={trigger}
      />
    </>
  )
}
